import { ACCOUNT_STATISTICS_HEADERS, AccountStatisticsHeaders } from 'utils/constants/admin';
import { DISABLE_OFF_SOURCES } from 'utils/constants/campaign';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import TableBody from 'components/Table/TableBody';
import TableCell from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useSelector } from 'store/utils';

const isHiddenSource = (item) =>
    item[AccountStatisticsHeaders.Impressions] === 0 &&
    DISABLE_OFF_SOURCES.includes(item[AccountStatisticsHeaders.Source]);

const AccountStatisticsTable = () => {
    const accountStatisticsData = useSelector((state) => state.accountStatistics.accountStatisticsData);
    const trl = useTrls();

    return (
        <Table fullWidth withStripes bordered>
            <TableHead>
                <TableRow>
                    {ACCOUNT_STATISTICS_HEADERS.map((header) => (
                        <TableHeadCell key={header}>
                            {trl(`admin.accountStatisticsReport.header.${header}`)}
                        </TableHeadCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {accountStatisticsData
                    .filter((item) => !isHiddenSource(item))
                    .map((item) => (
                        <TableRow key={item.source}>
                            {ACCOUNT_STATISTICS_HEADERS.map((header) => (
                                <TableCell key={header}>{item[header]}</TableCell>
                            ))}
                        </TableRow>
                    ))}
            </TableBody>
        </Table>
    );
};

export default AccountStatisticsTable;
